import { useState, useEffect } from 'react';

const API = process.env.REACT_APP_BACKEND_URL || window.location.origin;

export function EnvironmentBadge() {
  const [env, setEnv] = useState(null);

  useEffect(() => {
    fetch(`${API}/api/env-info`)
      .then(r => r.json())
      .then(d => setEnv(d.environment))
      .catch(() => {});
  }, []);

  if (!env || env === 'production') return null;

  const colors = {
    staging: 'bg-amber-500 text-black',
    development: 'bg-blue-500 text-white',
  };

  return (
    <div
      className={`fixed top-0 left-1/2 -translate-x-1/2 z-[9999] px-3 py-0.5 text-[10px] font-bold uppercase tracking-wider rounded-b-md ${colors[env] || 'bg-gray-500 text-white'}`}
      data-testid="environment-badge"
    >
      {env}
    </div>
  );
}
